import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Calculator } from '@ratehub/base-ui';
import AmortizationCalcInputStep from './AmortizationCalcInputStep';
import AmortizationCalcChartStep from './AmortizationCalcChartStep';


function AmortizationCalculator({ ...otherProps }) {
    return (
        <Calculator
            className="rh-max-width-50"
            title={(
                <FormattedMessage
                    id="calculators.AmortizationCalculator.calculatorTitle"
                    defaultMessage="Ratehub.ca’s amortization calculator"
                />
            )}
            {...otherProps}
        >
            <AmortizationCalcInputStep />

            <AmortizationCalcChartStep stepNumber={2} />
        </Calculator>
    );
}


export default observer(AmortizationCalculator);
